class Tabs extends HTMLElement {

  constructor() {
    super();
    this.hasInitializedAccordions = false;
    this.init();
  }

  init() {
    
    this.tabs = this.querySelectorAll('[data-tab-heading-index]');
    this.contents =  this.querySelectorAll('[data-tab-content-index]');
    this.tabsQty = this.contents.length || 0;

    this.tabs.forEach( (tab) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        this.activateTab(tab.dataset.tabHeadingIndex);
      });

      tab.addEventListener('keydown', (event) => {
        this.keydownBehavior(event.keyCode);
      });
    });

    if(this.tabs[0]){
        this.tabs[0].click();
    }

    this.SelectTabFromUrl();

    this.querySelectorAll('summary[role="button"]').forEach((summary) => {
      summary.removeAttribute('role');
    });

  }

  SelectTabFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const tabLabel = urlParams.get('tab');
    const itemPosition = urlParams.get('faq');

    if (tabLabel) {
      const matchingTab = Array.from(this.tabs).find(
        tab => tab.dataset.tabLabel === tabLabel
      );

      if (matchingTab) {
        const index = parseInt(matchingTab.dataset.tabHeadingIndex);
        this.activateTab(index);

        if (!itemPosition) {
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        if (itemPosition) {
          const controlsId = matchingTab.getAttribute('aria-controls');
          const targetPanel = this.querySelector(`#${controlsId}`);
          const isVideoGrid = targetPanel?.querySelector('.tabs__content-video') !== null;

          if(isVideoGrid){
            this.activateVideoModalByParam(itemPosition);
          }else{
            this.activateAccordionByParam(itemPosition);
          }
        }

      }
    }
  }

  activateTab(index) {
    this.activeIndex = index;

    if (!this.tabs[this.activeIndex] || !this.contents[this.activeIndex]) return;

    // Reset accordions and mark if they are visible
    if (!this.hasInitializedAccordions) {
      this.hasInitializedAccordions = true;
    } else {
      this.contents.forEach((content, i) => {
        const isActive = i === this.activeIndex;
        content.querySelectorAll('smooth-accordion').forEach((acc) => {
          acc.isAnimating = false;
          acc.isVisible = isActive;
          const trigger = acc.querySelector('.accordion__trigger');
          const panel = acc.querySelector('.accordion__content');
          if (!trigger || !panel) return;
          trigger.setAttribute('aria-expanded', 'false');
          acc.removeAttribute('data-open');
          panel.setAttribute('hidden', '');
          panel.style.maxHeight = '0px';
        });
      });
    }

    // Disable all active tabs
    this.tabs.forEach((tab) => {
      tab.parentElement.classList.remove('active');
      tab.classList.remove('active');
      tab.setAttribute("aria-selected", "false");
      tab.setAttribute("tabindex", "-1");
    });

    this.contents.forEach((content) => {
        content.classList.remove('active');
        content.setAttribute("aria-hidden", "true");
    });

    // Enable all active classes
    this.tabs[this.activeIndex].parentElement.classList.add('active');
    this.tabs[this.activeIndex].classList.add('active');
    this.tabs[this.activeIndex].setAttribute("aria-selected", "true");
    this.tabs[this.activeIndex].setAttribute("tabindex", "0");
    this.contents[this.activeIndex].classList.add('active');
    this.contents[this.activeIndex].setAttribute("aria-hidden", "false");
  }

   activateAccordionByParam(itemPosition) {
    setTimeout(() => {
      const activeTab = this.querySelector('.tabs__content.active');
      const targetAccordion = activeTab?.querySelector(`smooth-accordion[data-accordion-order="${itemPosition}"]`);
      if (targetAccordion) {
        const trigger = targetAccordion.querySelector('.accordion__trigger');
        if (trigger && trigger.getAttribute('aria-expanded') === 'false') {
          trigger.click();
        }
        targetAccordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 300);
  }

  activateVideoModalByParam(itemPosition) {
    setTimeout(() => {
      const activeTab = this.querySelector('.tabs__content.active');
      const targetVideo = activeTab?.querySelector(`.tabs__video-item-wrapper[data-video-order="${itemPosition}"]`);
      if (targetVideo) {
        targetVideo.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(() => {
          const trigger = targetVideo.querySelector('button.video-modal__open-modal');
          trigger?.click();
        }, 800);
      }
    }, 300);
  }

  keydownBehavior(keyCode){
    let activatedIndex = parseInt(this.activeIndex, 10);
    let maxIndex = this.tabs.length - 1;
    let newIndex = -1;

    // Left / Up arrow
    if (keyCode === 37 || keyCode === 38) {
      newIndex = (activatedIndex === 0) ? maxIndex : activatedIndex - 1;
    }

    // Right arrow / Down arrow
    if (keyCode === 39 || keyCode === 40) {
      newIndex = (activatedIndex === maxIndex) ? 0 : activatedIndex + 1;
    }

    if (newIndex > -1 && this.tabs[newIndex]) {
      this.activateTab(parseInt(newIndex));
      this.tabs[this.activeIndex].focus();
    }
  }

}

if (!customElements.get('tabs-component')) {
  customElements.define('tabs-component', Tabs);
}